import { memo } from "react";
import { Nav } from "react-bootstrap"

export const getTabsConfig = (ppc_paused = false, isClusterTable, isHTR) => {
  const config = [
    { title: "Active", value: 1, counterKey: "activeRecords" },
    { title: "Inactive", value: isClusterTable ? 2 : 3, counterKey: "inactiveRecords" },
    { title: "All", value: 0, counterKey: "total" },
  ];

  const paused_el = { title: "Paused", value: 5, counterKey: "pausedRecords" }
  if (ppc_paused) {
    config.splice(0, 1, paused_el)
  }
  if (!isClusterTable) {
    if (isHTR) {
      const insertAfterIdx = config.findIndex(t => t.title === "Inactive");
      if (insertAfterIdx !== -1) {
        config.splice(insertAfterIdx + 1, 0, { title: "Not Bidding", value: 4, counterKey: "notBiddingRecords", });
      }
    }
    config.splice(1, 0, {...paused_el, value: 2})
  }
  return config;
};

export const CampaignTableFilters = memo(({ 
  countByStatus = null,
  status, 
  setStatus, 
  ppc_paused = false, 
  isClusterTable = false, 
  isHTR = false 
}) => {
  const tabsConfig = getTabsConfig(ppc_paused, isClusterTable, isHTR);
  return (
      <Nav className={`nav-line mb-4 ${isClusterTable ? "justify-content-end" : ""}`} style={{ width: "100%" }}>
          {tabsConfig.map(({ title, value, counterKey }) => {
              let tabContent = title;
              if (countByStatus) {
                  tabContent += ` (${countByStatus[counterKey]})`;
              }
              return (
                  <Nav.Link key={value} onClick={() => setStatus(value)} className={status === value ? "active" : ""}>
                      {tabContent}
                  </Nav.Link>
              )
          })}
      </Nav>
  )
})
